import Vue from 'vue'
import App from './App.vue'
import router from './router'
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import Datetime from 'vue-datetime'
import 'vue-datetime/dist/vue-datetime.css'
import Axios from 'axios'
import VueSweetalert2 from 'vue-sweetalert2';
import VueScrollTo from 'vue-scrollto';
import Dygraph from 'dygraphs';
import VueCharts from 'vue-chartjs'
import zoom from 'chartjs-plugin-zoom';
//import io from 'socket.io-client'
//import VueSocketIO from 'vue-socket.io'
import configFile from "./config.json";
import VTooltip from 'v-tooltip'

//var  socket = io();
import { library } from '@fortawesome/fontawesome-svg-core'
import { faUserSecret } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(faUserSecret)

Vue.component('font-awesome-icon', FontAwesomeIcon)

/*
Vue.use(new VueSocketIO({ 
  connection: socket
}))*/


//import syncDygraph from './node_modules/dygraphs/src/extras/synchronizer.js';

Object.defineProperty(Vue.prototype, '$Dygraph', { value: Dygraph });
//Object.defineProperty(Vue.prototype, '$DygraphSync', { value: syncDygraph });
Object.defineProperty(Vue.prototype, '$configFile', { value: configFile });
Vue.use(VueScrollTo)

Vue.use(VueCharts)
Vue.use(Datetime)
Vue.prototype.$http = Axios;
Vue.use(BootstrapVue);
Vue.use(require('vue-moment'));
Vue.use(VueSweetalert2);
Vue.use(zoom);
Vue.use(VTooltip);

import VueApexCharts from 'vue-apexcharts'

Vue.component('apexchart', VueApexCharts)

Vue.config.productionTip = false

new Vue({
    router,

    render: h => h(App)
}).$mount('#app')
